module.exports = __webpack_public_path__ + "img/pen-suit (2).89e2ec18.png";